<template>
  <div></div>
</template>
<script>
export default {
  mounted() {
    document.title = `${this.$rhrCoreShellOptions.name} | OpenID Connect Callback`;
  },
  beforeDestroy() {
    document.title = `${this.$rhrCoreShellOptions.name}`;
  }
};
</script>
